import { prop, path } from 'ramda';

import { FEATURE_NAME as $ } from './consts';

export const getTeam = prop($);
export const getMember = (id) => path([$, id]);
export const getMemberProp = (id) => (name) => path([$, id, name]);
